"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDenormalizedSchema = exports.AlternateFunctionDenormalizedSchema = exports.StructureDenormalizedSchema = exports.DifferentialPairDenormalizedSchema = exports.VariantDenormalizedSchema = void 0;
const zod_1 = require("zod");
exports.VariantDenormalizedSchema = zod_1.z
    .object({
    variantKey: zod_1.z.string().min(1),
    device: zod_1.z.string().min(1),
    orderableMpns: zod_1.z.array(zod_1.z.string().min(1)),
    packageFamilyName: zod_1.z.string().min(1),
    pinCount: zod_1.z.number().int().positive(),
    sharedCore: zod_1.z.boolean(),
    featureVariant: zod_1.z.string().nullable(),
})
    .strict();
exports.DifferentialPairDenormalizedSchema = zod_1.z
    .object({
    positiveSignalName: zod_1.z.string().min(1),
    negativeSignalName: zod_1.z.string().min(1),
    pairName: zod_1.z.string().nullable(),
})
    .strict();
exports.StructureDenormalizedSchema = zod_1.z
    .object({
    variantKey: zod_1.z.string().min(1),
    numPins: zod_1.z.number().int().positive(),
    numPads: zod_1.z.number().int().positive().nullable(),
    exposedPadNote: zod_1.z.string().nullable(),
})
    .strict();
exports.AlternateFunctionDenormalizedSchema = zod_1.z
    .object({
    pinName: zod_1.z.string().min(1),
    afIndex: zod_1.z.number().int().min(0).nullable(),
    functionName: zod_1.z.string().min(1),
})
    .strict();
exports.PackageDenormalizedSchema = zod_1.z
    .object({
    variantKey: zod_1.z.string().min(1),
    manufacturerPartNumberPrimary: zod_1.z.string().min(1),
    manufacturerName: zod_1.z.string().min(1),
    sigmaModelType: zod_1.z.string().min(1),
    groupRefs: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
})
    .strict();
//# sourceMappingURL=ade-ir-denormalized.js.map